// reducers/noteReducer.js
import { SET_NOTE_FINALE } from "../actions/noteActions";

const initialState = {
  noteData: null,
};

export default function noteReducer(state = initialState, action) {
  switch (action.type) {
    case SET_NOTE_FINALE:
      console.log("🛠 [noteReducer] Payload reçu:", action.payload);
      return {
        ...state,
        noteData: action.payload,
      };
    default:
      return state;
  }
}
